
export enum ToastType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
  Default = 'default',
  Clickable = 'clickable'
}

export class ShowNotificationAction {
  static readonly type = '[Core] show notification';
  constructor(public payload: { title?: string, message: string, notificationType?: ToastType }) {}
}

export class ShowTimeoutNotificationAction {
  static readonly type = '[Core] show timeout notification';
  constructor(public payload: { title?: string, message: string, notificationType?: ToastType, closeButton?:boolean,progressBar?:boolean, timeout?:number }) {}
}

export class GetMenuAction {
  static readonly type = '[Core] get menu';
}

export class RegisterServerError {
  static readonly type = '[Core] Register Server Error';
  constructor(public payload: {error: any}) {}
}
export class ClearServerError {
  static readonly type = '[Core] Clear Server Error';
  constructor(public payload: {}) {}
}
